// extracted by mini-css-extract-plugin
export default {"root":"QuickActionWrapper__root__y7xj6"};